import { render, staticRenderFns } from "./InvoiceOrderCard.vue?vue&type=template&id=4213ff2e&"
import script from "./InvoiceOrderCard.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOrderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports